var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "eventDetails" },
    [
      _vm.error
        ? _c("div", { staticClass: "error" }, [
            _vm._v("\n\t\t" + _vm._s(_vm.error) + "\n\t\t"),
            _c("div", { staticClass: "tryAgain" }, [
              _c("input", {
                attrs: { type: "button", value: "Try Again" },
                on: { click: _vm.loadEvent }
              })
            ])
          ])
        : _vm.loading
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("ScaleLoader"), _vm._v(" Loading…")],
            1
          )
        : _vm.event
        ? _c("div", { staticClass: "eventBody" }, [
            _c("div", {
              staticClass: "title",
              style: _vm.titleBarStyle,
              attrs: {
                title:
                  "Event ID: " +
                  _vm.event.EventId +
                  ", Color: #" +
                  _vm.event.Color
              },
              domProps: { textContent: _vm._s(_vm.event.Message) }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "subTitle",
                attrs: {
                  title:
                    "EventType: " +
                    _vm.event.EventType +
                    ", SubType: " +
                    _vm.event.SubType
                }
              },
              [
                _c("span", { staticClass: "eventType" }, [
                  _vm._v(_vm._s(_vm.event.EventType) + ":")
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "subType",
                  domProps: { textContent: _vm._s(_vm.event.SubType) }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("b", [_vm._v("Folder:")]),
                _vm._v(" "),
                _c("router-link", { attrs: { to: _vm.routeToFolder } }, [
                  _vm._v(_vm._s(_vm.folderPath))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm.routeToMatchingEvents
              ? _c(
                  "div",
                  [
                    _c(
                      "router-link",
                      { attrs: { to: _vm.routeToMatchingEvents } },
                      [
                        _vm._v(
                          _vm._s(_vm.event.MatchingEvents) + " events like this"
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "date" }, [
              _c("span", {
                staticClass: "dateValue",
                domProps: {
                  textContent: _vm._s(
                    _vm.eventDateFormat(new Date(_vm.event.Date))
                  )
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "messageContainer" }, [
              _c("div", { staticClass: "messageHeading" }, [_vm._v("Message")]),
              _vm._v(" "),
              _c("div", {
                staticClass: "messageBody",
                domProps: { textContent: _vm._s(_vm.event.Message) }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tagContainer" }, [
              _c("table", { staticClass: "tagTable" }, [
                _c(
                  "tbody",
                  _vm._l(_vm.event.TagList, function(tag, index) {
                    return _c("tr", { key: index, staticClass: "tagRow" }, [
                      _c("td", {
                        staticClass: "tagKey",
                        domProps: { textContent: _vm._s(tag.Key) },
                        on: {
                          contextmenu: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.onTagKeyContextMenu($event, tag)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("td", {
                        staticClass: "tagValue",
                        domProps: { textContent: _vm._s(tag.Value) }
                      })
                    ])
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "filtersAppliedHeading title",
                style: _vm.titleBarStyle
              },
              [_vm._v("\n\t\t\tFilters Applied to this Event\n\t\t")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "tagContainer" }, [
              _c("table", { staticClass: "tagTable" }, [
                _c(
                  "tbody",
                  _vm._l(_vm.event.FiltersApplied, function(fa, index) {
                    return _c("tr", { key: index, staticClass: "tagRow" }, [
                      _c(
                        "td",
                        { staticClass: "filterAppliedCell" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: _vm.getRouteToFilterDetails(fa.FilterId)
                              }
                            },
                            [_vm._v("#" + _vm._s(fa.FilterId))]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", { staticClass: "filterAppliedCell" }, [
                        _vm._v(_vm._s(_vm.eventDateFormat(new Date(fa.Date))))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "filterAppliedCell" }, [
                        _vm._v(_vm._s(fa.FilterName))
                      ])
                    ])
                  }),
                  0
                )
              ])
            ])
          ])
        : _c("div", { staticClass: "noEvent" }, [
            _vm._v("\n\t\t[no event selected]\n\t")
          ]),
      _vm._v(" "),
      _c("vue-context", {
        ref: "tagKeyMenu",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(tagName) {
              return [
                _c("li", { attrs: { if: "tagName.data" } }, [
                  _c(
                    "a",
                    {
                      attrs: { role: "button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.setEventListCustomTagKey(tagName.data)
                        }
                      }
                    },
                    [
                      _vm._v(
                        'Show "' + _vm._s(tagName.data) + '" in Event List'
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.eventListCustomTagKey
                  ? _c("li", [
                      _c(
                        "a",
                        {
                          attrs: { role: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.setEventListCustomTagKey(null)
                            }
                          }
                        },
                        [
                          _vm._v(
                            'Remove "' +
                              _vm._s(_vm.eventListCustomTagKey) +
                              '" from Event List'
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }